import snakeCase from 'lodash/snakeCase';
import PropTypes$1 from 'prop-types';

/**
 * Core
 */
var history = PropTypes$1.shape({
  listen: PropTypes$1.func.isRequired,
  push: PropTypes$1.func.isRequired
});
var location = PropTypes$1.shape({
  pathname: PropTypes$1.string,
  search: PropTypes$1.string
});
var intl = PropTypes$1.shape({
  locale: PropTypes$1.string.isRequired,
  formatMessage: PropTypes$1.func.isRequired
});
var defaultMessageContent = PropTypes$1.shape({
  type: PropTypes$1.number,
  value: PropTypes$1.string
});
var defaultMessage = PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.arrayOf(defaultMessageContent)]);
var message = PropTypes$1.shape({
  id: PropTypes$1.string,
  defaultMessage: defaultMessage.isRequired,
  description: PropTypes$1.string
});
var text = PropTypes$1.oneOfType([message, PropTypes$1.string]);
var label = PropTypes$1.oneOfType([message, PropTypes$1.node]);
var statusCode = PropTypes$1.oneOf([401, 403, 404, 500]);

/**
 * Site
 */
var user = PropTypes$1.shape({
  id: PropTypes$1.number,
  firstname: PropTypes$1.string,
  lastname: PropTypes$1.string,
  email: PropTypes$1.string
});
var menuItem = PropTypes$1.shape({
  id: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
  label: label,
  url: PropTypes$1.string,
  external: PropTypes$1.bool,
  active: PropTypes$1.bool
});
var menuItems = PropTypes$1.arrayOf(menuItem);
var componentNames = function componentNames(Components) {
  return PropTypes$1.oneOf(Object.keys(Components).map(function (it) {
    return snakeCase(it);
  }));
};
var component = PropTypes$1.shape({
  id: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]),
  uuid: PropTypes$1.string,
  role: PropTypes$1.string,
  type: PropTypes$1.string
});
var components = PropTypes$1.arrayOf(component);

var PropTypes = /*#__PURE__*/Object.freeze({
    __proto__: null,
    component: component,
    componentNames: componentNames,
    components: components,
    defaultMessage: defaultMessage,
    defaultMessageContent: defaultMessageContent,
    history: history,
    intl: intl,
    label: label,
    location: location,
    menuItem: menuItem,
    menuItems: menuItems,
    message: message,
    statusCode: statusCode,
    text: text,
    user: user
});

export { PropTypes };
